<template>
  <div class="pageHeader">
    <!--     v-if="this.$route.name !== 'favorite'"-->
    <div class="search_div text_center">
      <el-input
        placeholder="请输入事项名称"
        v-model="SearchItem"
        class="appall_search_input_css"
        size="mini"
        @change="toSearch"
      >
        <i
          slot="suffix"
          style="color: #000;font-size: 17px;"
          class="el-input__icon el-icon-search"
          @click="toSearch"
        />
      </el-input>
    </div>

    <ul class="mobile_nav text_center hasBottom">
      <li
        v-for="it in serviceTip"
        :key="it.id"
        :class="it.id === targetNow && 'active'"
        @click="changePanel(it)"
      >
        {{ it.title }}
      </li>
    </ul>
  </div>
</template>

<script>
import { EventBus } from "@/api/eventbus";
export default {
  name: "CommonAppNav",
  inject: ["isPage"],
  watch: {
    "$route.name": {
      handler(val, oldVal) {
        if (val !== oldVal) {
          if (this.isPage("favorite")) {
            this.targetNow = "collect";
          } else {
            let targetNow = sessionStorage.getItem("targetNow");

            // token
            if(this.$store.getters.getAuth.access_token){
              this.changePanel({ id: targetNow || "tag" });
            }
          }
        }
      },
      immediate: true
    },
  },
  data() {
    return {
      SearchItem: "",
      targetNow: "tag",
      serviceTip: [
        // {
        //   id: 'other',
        //   title: '按对象',
        // },
        {
          id: "tag",
          title: "按主题",
        },
        {
          id: "dep",
          title: "按部门",
        },
        {
          id: "zimu",
          title: "按字母",
        },
        {
          id: "collect",
          title: "我的收藏",
        },
      ],
    };
  },
  mounted() {
    // console.log(this.targetNow, '-----?')
  },
  computed: {
    itemLength() {
      return this.$store.getters.getDataLength;
    },
  },
  methods: {
    changePanel(e) {
      if(this.$store.getters.getAuth.access_token){
        this.targetNow = e.id;
      this.SearchItem = null;
      this.$store.dispatch("updateQuery", {
        seq: "all",
        dep: "all",
        tag: "all",
        other: "all",
        zimu: "all",
      });

      sessionStorage.setItem("targetNow", this.targetNow);

      if (e.id == "collect") {
        this.$router.push({ name: "favorite" });
      } else {
        setTimeout(() => {
          EventBus.$emit("changePanel", e.id);
        });
        if (!this.isPage("serviceC")) {
          this.$router.push({ name: "serviceC" });
        }
      }

      }else{
        sessionStorage.setItem('hasSigned', true)
        this.$router.push({ name: "apps" });

      }
      
    },
    toSearch() {
      this.targetNow = !this.SearchItem ? "tag" : "keyword";
      // this.$store.commit("updateAppAll", {seq: this.SearchItem, });
      this.$store.dispatch("updateQuery", {
        seq: this.SearchItem || "all",
        dep: "all",
        tag: "all",
        other: "all",
        zimu: "all",
      });
      setTimeout(() => {
        EventBus.$emit("changePanel", !this.SearchItem ? "tag" : "keyword");
      });

      if (!this.isPage("serviceC")) {
        this.$router.push({ name: "serviceC" });
      }
    },
  },
};
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/wechat/modules/CommonAppNav.vue